import { either, equals } from 'ramda';

export const offerCodeEnum = Object.freeze({
  INDIVIDUAL_HEALTH: 'INDIVIDUAL_HEALTH',
  INDIVIDUAL_PROTECTION_DAILY_BENEFIT: 'INDIVIDUAL_PROTECTION_DAILY_BENEFIT',
  SELF_EMPLOYED_WORKER_PROTECTION: 'SELF_EMPLOYED_WORKER_PROTECTION',
  GROUP_HEALTH: 'GROUP_HEALTH',
  GROUP_PROTECTION: 'GROUP_PROTECTION'
});

// Offres collectives : santé collective et prévoyance collective
export const isGroupOffer = (code) =>
  either(equals(offerCodeEnum.GROUP_HEALTH), equals(offerCodeEnum.GROUP_PROTECTION))(code);
